import type { Lang } from "./config";
import { sv } from "./locales/sv";
import { en } from "./locales/en";
import { es } from "./locales/es";

export const RESOURCES: Record<Lang, { translation: Record<string, unknown> }> = {
  sv: { translation: sv },
  en: { translation: en },
  es: { translation: es },
};
